export const getTeams = state => state.team.team;
export const getTeamMembers = state => state.team.team.roster;
export const selectMyInfoOnTeam = state => state.team.team.me;